import React, {useState} from 'react';
import {GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup} from "firebase/auth";
import {auth} from '../../firebase';
import './Login.css';
import {useNavigate} from "react-router-dom";

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [acceptTerms, setAcceptTerms] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!acceptTerms) {
            setError('Παρακαλώ συμφωνήστε με τους Όρους & Προϋποθέσεις και την Πολιτική Απορρήτου');
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/map');
        } catch (error) {
            if (error.code === 'auth/wrong-password') {
                // Additional handling if desired
            } else if (error.code === 'auth/too-many-requests') {
                // Additional handling if desired
            } else {
                setError(error.message);
            }
        }
    };

    const handleGoogleSignIn = async () => {
        if (!acceptTerms) {
            setError('Παρακαλώ συμφωνήστε με τους Όρους & Προϋποθέσεις και την Πολιτική Απορρήτου');
            return;
        }
        const provider = new GoogleAuthProvider();
        try {
            await signInWithPopup(auth, provider);
            navigate('/map');
        } catch (error) {
            setError(error.message);
        }
    };

    return (<div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
            <h2>Σύνδεση</h2>
            <div>
                <label>Ηλεκτρονικό ταχυδρομείο:</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
            </div>
            <div>
                <label>Κωδικός πρόσβασης:</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
            </div>
            {/* Terms & Privacy Checkbox */}
            <div className="terms-container">
                <input
                    type="checkbox"
                    id="acceptTerms"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                />
                <label htmlFor="acceptTerms">
                    Συμφωνώ με τους&nbsp;
                    <a href="/documents/RGD%20Map-%20Terms%20of%20conditions.pdf" target="_blank"
                       rel="noopener noreferrer">
                        Όρους & Προϋποθέσεις
                    </a>
                    &nbsp;και την&nbsp;
                    <a href="/documents/RDG%20Map%20Privacy%20Policy_%20v1.0.pdf" target="_blank"
                       rel="noopener noreferrer">
                        Πολιτική Απορρήτου
                    </a>
                </label>
            </div>
            {error && <p className="error-message">{error}</p>}
            <button type="submit" disabled={!acceptTerms}>Σύνδεση</button>
        </form>
        <div className="google-signin-container">
            <p>Συνδεθείτε με</p>
            <div
                className={`google-signin-button ${!acceptTerms ? 'disabled' : ''}`}
                onClick={handleGoogleSignIn}
            >
                <img src="/google_logo.png" alt="Google logo"/>
                <span>Google</span>
            </div>
            <p className="google-signin-info">
                Μπορείτε να συνδεθείτε και με τους λογαριασμούς σας στην Google αφού πρώτα αποδεχτείτε τους Όρους και
                τις Προϋποθέσεις, καθώς και την Πολιτική Απορρήτου.
            </p>
        </div>
        <div className="register-link">
            <p>Δεν έχετε λογαριασμό; <a href="/register">Εγγραφείτε εδώ</a></p>
        </div>
    </div>);
};

export default Login;
